import React, { useState, useEffect } from 'react';
import axios from "axios";
// import '../Master.css';

const HTMLComponent = (props) => {
    const [html, setHTML] = useState('');

    
    useEffect(() => {
       setHTML(props.html)
    }, [props]);
  
    return <>
    <div dangerouslySetInnerHTML={{__html:html}}></div>
    </>
}
export default HTMLComponent;

